"use strict";
/*
 * Created on 29.06.2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var utils_1 = require("../../core/utils");

var WindowSearchIndex_1 = require("../model/WindowSearchIndex");

var WindowSearchIndexConverter_1 = require("./WindowSearchIndexConverter");
/**
 * Default implementation of {@link WindowSearchIndexConverter}.
 * @author Radek Beran
 */


var WindowSearchIndexConverterImpl =
/*#__PURE__*/
function (_WindowSearchIndexCon) {
  _inherits(WindowSearchIndexConverterImpl, _WindowSearchIndexCon);

  function WindowSearchIndexConverterImpl() {
    _classCallCheck(this, WindowSearchIndexConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowSearchIndexConverterImpl).apply(this, arguments));
  }

  _createClass(WindowSearchIndexConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WindowSearchIndex_1.WindowSearchIndex( // Window attributes:
      WindowSearchIndex_1.WindowSearchIndex.schema.id.valueOf(conversions.documentToClassId(source)), WindowSearchIndex_1.WindowSearchIndex.schema.from.valueOfField(source), WindowSearchIndex_1.WindowSearchIndex.schema.to.valueOfField(source), !utils_1.Utils.isValueMissing(source.texts) ? WindowSearchIndex_1.WindowSearchIndex.schema.texts.valueOf(source.texts) : immutable_1.List(), WindowSearchIndex_1.WindowSearchIndex.schema.portfolio.valueOf(conversions.toClassReferenceId(source.portfolio)), WindowSearchIndex_1.WindowSearchIndex.schema.themeId.valueOf(source.themeId ? conversions.toClassReferenceId(source.themeId) : null), WindowSearchIndex_1.WindowSearchIndex.schema.typeId.valueOf(conversions.toClassReferenceId(source.typeId)), WindowSearchIndex_1.WindowSearchIndex.schema.wfState.valueOfField(source), // Promotion attributes:
      WindowSearchIndex_1.WindowSearchIndex.schema.pId.valueOf(conversions.toClassReferenceId(source.pId)), !utils_1.Utils.isValueMissing(source.pTexts) ? WindowSearchIndex_1.WindowSearchIndex.schema.pTexts.valueOf(source.pTexts) : immutable_1.List(), WindowSearchIndex_1.WindowSearchIndex.schema.pFrom.valueOfField(source), WindowSearchIndex_1.WindowSearchIndex.schema.pTo.valueOfField(source), WindowSearchIndex_1.WindowSearchIndex.schema.pStore.valueOfField(source), // Product attributes:
      !utils_1.Utils.isValueMissing(source.prTexts) ? WindowSearchIndex_1.WindowSearchIndex.schema.prTexts.valueOf(source.prTexts) : immutable_1.List(), WindowSearchIndex_1.WindowSearchIndex.schema.prCount.valueOfField(source), !utils_1.Utils.isValueMissing(source.prIds) ? WindowSearchIndex_1.WindowSearchIndex.schema.prIds.valueOf(source.prIds) : immutable_1.List());
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        from: conversions.fromDate(source.from),
        to: conversions.fromDate(source.to),
        texts: source.texts.toArray(),
        portfolio: conversions.toDocumentReferenceId(source.portfolio),
        themeId: source.themeId !== null ? conversions.toDocumentReferenceId(source.themeId) : null,
        typeId: conversions.toDocumentReferenceId(source.typeId),
        wfState: source.wfState,
        // Promotion attributes:
        pId: conversions.toDocumentReferenceId(source.pId),
        pTexts: source.pTexts.toArray(),
        pFrom: conversions.fromDate(source.pFrom),
        pTo: conversions.fromDate(source.pTo),
        pStore: source.pStore,
        // Product attributes:
        prTexts: source.prTexts.toArray(),
        prCount: source.prCount,
        prIds: source.prIds.toArray()
      });
      return result;
    }
  }]);

  return WindowSearchIndexConverterImpl;
}(WindowSearchIndexConverter_1.WindowSearchIndexConverter);

exports.WindowSearchIndexConverterImpl = WindowSearchIndexConverterImpl;